module.exports = __webpack_public_path__ + "static/img/fullscreen-image_lets-get_600.45f5e55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/fullscreen-image_lets-get_600.png
// module id = 6VUo
// module chunks = 0